import { TemplateRef } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { MODAL_CONFIG } from '../../../services/constant';
import { TranslateService } from '@ngx-translate/core';
var ProfileListDetailComponent = (function () {
    function ProfileListDetailComponent(apiService, modalService, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.translate = translate;
        this.user = {};
        this.groups = [];
        this.title = '';
        this.createMode = false;
        this.errorMessage = null;
        this.errorMsgForShow = null;
        this.errorMsgForShows = null;
        this.passwordPlaceHolder = '';
        this.parent = null;
    }
    ProfileListDetailComponent.prototype.open = function (parent, selectedUser) {
        this.parent = parent;
        this.errorMessage = null;
        if (selectedUser != null) {
            this.user = _.cloneDeep(selectedUser);
            this.user.group = this.user.group.id;
            delete this.user.status;
            this.createMode = false;
            this.title = this.translate.instant('PROFILE.LIST.MODAL.TITLE') + ' : ' + this.user.username;
            this.passwordPlaceHolder = '(' + this.translate.instant('PROFILE.LIST.MODAL.PASSWORD-PLACEHOLDER') + ')';
        }
        else {
            this.user = { "group": this.groups[0]['value'] };
            this.createMode = true;
            this.title = this.translate.instant('PROFILE.LIST.MODAL.ADD-USER');
            this.passwordPlaceHolder = this.translate.instant('PROFILE.LIST.MODAL.PASSWORD');
        }
        this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
    };
    ProfileListDetailComponent.prototype.ngOnInit = function () {
        this.loadGroups();
    };
    ProfileListDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.translate.currentLang !== 'en') {
            var errorField = [];
            this.errorMessage = null;
            if (this.user.username == null || this.user.username.length == 0)
                errorField.push("ชื่อผู้ใช้งาน");
            if (this.createMode && (this.user.password == null || this.user.password.length == 0))
                errorField.push("รหัสผ่าน");
            if (errorField.length > 0) {
                this.errorMessage = "โปรดกรอก " + errorField.join(', ') + ' ให้ถูกต้อง';
                return;
            }
        }
        else {
            var errorField = [];
            this.errorMessage = null;
            if (this.user.username == null || this.user.username.length == 0)
                errorField.push("Username");
            if (this.createMode && (this.user.password == null || this.user.password.length == 0))
                errorField.push("Password");
            if (errorField.length > 0) {
                this.errorMessage = "Please fill " + errorField.join(', ') + ' correctly';
                return;
            }
        }
        var request = null;
        if (this.createMode)
            request = this.apiService.createUser(this.user);
        else
            request = this.apiService.updateUser(this.user);
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
            _this.clearData();
        }, function (error) {
            _this.checkErrorMsg(error);
        });
    };
    ProfileListDetailComponent.prototype.checkErrorMsg = function (error) {
        // this.errorMsgForShow = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === 'en') {
            this.errorMessage = 'This username have already exists';
        }
        else {
            this.errorMessage = 'ชื่อผู้ใช้นี้มีอยู่แล้ว';
        }
    };
    ProfileListDetailComponent.prototype.clearData = function () {
        this.user = {};
        this.errorMsgForShow = null;
    };
    ProfileListDetailComponent.prototype.close = function () {
        this.modalRef.hide();
        this.clearData();
    };
    ProfileListDetailComponent.prototype.disableUser = function () {
        var _this = this;
        var request = this.apiService.deleteUser(this.user);
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
        }, function (error) {
            // this.errorMessage = this.apiService.getErrorMessage(error);
            _this.checkErrorallMsg(error);
        });
    };
    ProfileListDetailComponent.prototype.enableUser = function () {
        var _this = this;
        this.user.is_active = true;
        var request = this.apiService.updateUser(this.user);
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
        }, function (error) {
            // this.errorMessage = this.apiService.getErrorMessage(error);
            _this.checkErrorallMsg(error);
        });
    };
    ProfileListDetailComponent.prototype.checkErrorallMsg = function (error) {
        this.errorMsgForShows = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === 'en') {
            this.errorMessage = this.errorMsgForShows[0];
        }
        else {
            this.errorMessage = this.errorMsgForShows[1];
        }
    };
    ProfileListDetailComponent.prototype.loadGroups = function () {
        var _this = this;
        this.groups = [];
        this.apiService.getGroups().subscribe(function (groups) {
            _.forEach(groups, function (group) {
                _this.groups.push({
                    'label': group['name'],
                    'value': group['id']
                });
            });
        }, function (error) {
        });
    };
    return ProfileListDetailComponent;
}());
export { ProfileListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.ts.pre-build-optimizer.js